export default __webpack_public_path__ + "static/media/import_lightbulb.ab3fb200.svg";